'use client';

import {
  Button,
  Dialog,
  DialogClose,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@commenda/kakashi';

interface SubmissionsWarningDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
}

export function SubmissionsWarningDialog({
  open,
  onOpenChange,
  onConfirm,
}: SubmissionsWarningDialogProps) {
  if (!open) return null;

  const handleConfirm = () => {
    onConfirm();
    onOpenChange(false);
  };

  return (
    <Dialog
      open={open}
      onOpenChange={(nextOpen) => {
        if (!nextOpen) {
          onOpenChange(false);
        }
      }}
    >
      <DialogContent>
        <DialogHeader className="flex flex-col gap-2 justify-start items-start">
          <DialogTitle>Template Has Existing Submissions</DialogTitle>
        </DialogHeader>
        <div className="space-y-4 py-4 px-4">
          <p className="text-sm text-text-tertiary">
            Proceeding with this update will modify the template structure,
            which may impact any existing form submissions that were created
            using this template.
          </p>
          <p className="text-sm text-text-tertiary">
            This template already has submissions. Updating it may affect
            existing submissions. Do you want to continue?
          </p>
        </div>
        <DialogFooter>
          <DialogClose asChild>
            <Button variant="secondary">Cancel</Button>
          </DialogClose>
          <Button variant="primary" onClick={handleConfirm}>
            Continue
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
